import { SET_USER_STATE, DROP_USER_STATE } from "../../constants"

export const setUserState = (user) => {
	return {
		type: SET_USER_STATE,
		payload: {
			user: user
		}
	}
};

export const dropUserState = () => {
	return {
		type: DROP_USER_STATE,
		payload: {
			user: {}
		}
	};
};


// WEBPACK FOOTER //
// ./src/api/auth/actions.js